module.exports = __webpack_public_path__ + "media/images/icon_btn_add_group-5c035bb02ea3cd59ef664be3446dc85c.png";